/**
 * Local feature flags. Flip or delete after a launch — do not leave stale flags.
 *
 * Override with VITE_FF_* in web/app/.env (`true` / `false`).
 */
const envFlag = (key: string, fallback: boolean): boolean => {
  const raw = (import.meta.env as Record<string, string | undefined>)[key]
  if (raw === 'true') return true
  if (raw === 'false') return false
  return fallback
}

export const FEATURE_FLAGS = {
  /**
   * First-run command palette coach mark + demo.
   * Off after launch. Set VITE_FF_COMMAND_PALETTE_ONBOARDING=true to show it again.
   */
  commandPaletteOnboarding: envFlag('VITE_FF_COMMAND_PALETTE_ONBOARDING', false),
  /**
   * First-run coach mark on the portal assistant sparkle.
   * Opens for Colton, Adam, and Bryan. Next commit after launch: set false.
   */
  portalAssistantOnboarding: envFlag('VITE_FF_PORTAL_ASSISTANT_ONBOARDING', true),
  /**
   * First-run tour for tool editing and chart switches.
   * The component only opens for colton@optictruckworks.com.
   */
  portalAssistantToolsOnboarding: envFlag('VITE_FF_PORTAL_ASSISTANT_TOOLS_ONBOARDING', true),
  /**
   * First-run coach mark on `/apply` (website financing).
   * Next commit after launch: set false (or delete WebsiteApplyOnboarding).
   */
  websiteApplyOnboarding: envFlag('VITE_FF_WEBSITE_APPLY_ONBOARDING', true),
  /**
   * Overview widget TTFD collector (`performance.mark` + sessionStorage).
   * Defaults on in Vite DEV; preview/staging also enable via host/project checks.
   */
  dashboardWidgetTimings: envFlag('VITE_FF_DASHBOARD_WIDGET_TIMINGS', false),
} as const
